import React from "react"
import Modal from "@/components/core/Modal/Modal"
import Button from "@/components/core/Button/Button"
import { sanitizeText } from "@/js/helperV2"

const OrderInReviewModal = props => {
  const {
    showAlert,
    handleClose,
    modalInfo: {
      modalTitle = "",
      modalDescription = "",
      buttonLabel = "",
      buttonHandler = () => {},
    },
  } = props

  return (
    <div className="order-inreview-warning">
      <Modal showModal={showAlert} onModalClose={() => handleClose()}>
        <div className="order-inreview-warning__modal">
          <p className="order-inreview-warning__modal-title">
            {sanitizeText(modalTitle)}
          </p>
          <p className="order-inreview-warning__modal-desc">
            {sanitizeText(modalDescription)}
          </p>

          <div className="order-inreview-warning__modal-cta">
            <Button
              className="gbh-data-layer"
              type="black"
              label={buttonLabel}
              onClick={() => {
                buttonHandler()
              }}
              tag={"button"}
            />
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default OrderInReviewModal
